import "../styles/globals.css";
import store from "../redux/store/index";
import { Provider } from "react-redux";
import { createWrapper } from "next-redux-wrapper";
import Head from "next/head";
import { useEffect, useState } from "react";
import router from "next/router";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import { useRouter } from 'next/router';
import "../components/imageLocalizer/AnimatedBanner.css";
import FloatingChatBot from "../components/bernardChatbot/FloatingChatBot";
import useBernardAccess from "../components/bernardChatbot/utils/useBernardAccess";
import { bindActionCreators } from "redux";
import { checkExpiry, sessionTimeOutCheck } from "../redux/global/actions";
import axios from "axios";
import endpoints from "../utility/endpoints";
import Modal from "../pages/successModal/index";
import { connect } from "react-redux";

const queryClient = new QueryClient();

const Wrapper = styled.div`
  *,
  ::before,
  ::after {
    border-width: 0;
    border-style: solid;
  }

  /* blockquote,
  dl,
  dd,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  hr,
  figure,
  p,
  pre {
    margin: 0;
  }

 

  
  
  .google-map * {
    border-style: none;
  } */

  ol,
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
li a{
  color:inherit;
}
  a {
    text-decoration: inherit;
  }
  img,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: block;
    vertical-align: middle;
    max-width: 100%;
    height: auto;
  }

  svg {
    height: 100%;
    display: block;
  }

  body {
    line-height: inherit;
  }
`;
function MyApp({ Component, pageProps,sessionTimeOutCheck,
  session }) {
  const router = useRouter();
  const [routeChangeState, setRouteChangeState] = useState(false);
  const[textActive,setTextActive] = useState(false);
  const [getCurrentPath, setGetCurrentPath] = useState('');
  const [isProductPage, setIsProductPage] = useState(false);
  const [sucessfullModal, setSuccessModal] = useState(false);
  const { isAccess } = useBernardAccess();
  const [mounted, setMounted] = useState(false);

    const checkAuthorization = async () => {
    let authData = JSON.parse(localStorage.getItem("auth"));
    if (!authData || !authData.data) {
      // Handle the case when authData or authData.data is falsy
      sessionTimeOutCheck(true);
      return; // Return without making the API call
    }
    try {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      const { data } = await axios({
        method: "GET",
        url: `${endpoints.baseUrl}/roi/checkAuthorization`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      });
      console.log("checkAuthorization", data);
      if (data.data.code === 200) {
        console.log("Authorized User", data.data);
      } else if (data.code === 403) {
        setTimeout(() => {
          sessionTimeOutCheck(true);
        }, 1000);
        console.log("Error in authorization", data);
      } else {
        sessionTimeOutCheck(true);
      }
    } catch (error) {
      console.log("Error in Authorization", error);
    }
  };
  useEffect(() => {
    checkAuthorization();
  }, []); 
  useEffect(() => {
    const handleStart = (url) => {	
      window.scrollTo(0, 0);
      url !== router.asPath && setRouteChangeState(true);
    };
    const handleComplete = (url) => setRouteChangeState(false);

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleComplete);
      setMounted(true);
    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleComplete);
    };
  }, []);

  const goTo = (link) => {
    router.push(link);
  };
  const handleMouseEnter = () => {
    setTextActive(true);
  };

  const handleMouseLeave = () => {
    setTextActive(false);
  };
  
  useEffect(() => {
    const currentURL = router.asPath;
    if (typeof window !== 'undefined') {
      setGetCurrentPath(window.location.pathname);
    }
     if (
      currentURL.includes("product") ||
      currentURL.includes("product_details") ||
      currentURL.includes("profile") ||
      currentURL.includes("return-on-investment") ||
      currentURL.includes("hall-of-fame") ||
      currentURL.includes("engagement-analytics") ||
      currentURL.includes("decision-automation") ||
      currentURL.includes("export-employeetwin") ||
      currentURL.includes("bulk-bot-update") ||
      currentURL.includes("BotStore") ||
      currentURL.includes("unite") ||
      currentURL.includes("createBotNew") ||
      currentURL.includes("change-request") ||
      currentURL.includes("bernard-chat") ||
      currentURL.includes("login") ||
      currentURL.includes("logout")
    ) {
      setIsProductPage(true);
    } else {
      setTimeout(() => {
        setIsProductPage(false);
      }, 1000);
    }
  }, [router.asPath]);
  console.log("getCurrentPath",getCurrentPath);
  console.log('isProductPage',isProductPage); 
  if (!mounted) return null;

   
  return (
    <Provider store={store}>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
       <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.6.0/css/bootstrap-grid.min.css"
        />
        {/*<link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/css/bootstrap.min.css"
          rel="stylesheet"
          integrity="sha384-KK94CHFLLe+nY2dmCWGMq91rCGa5gtU4mk92HdvYe+M/SXH301p5ILy+dN9+nJOZ"
          crossorigin="anonymous"
        ></link>*/}
        <title> Automation Factory - Bot Store </title>
        <link
          rel="icon"
          href="/sites/default/files/2021-05/Unilever%20logo_login%20page.svg"
          type="image/png"
        ></link>
{/* Added Google Analytics  */} 
          <script async src="https://www.googletagmanager.com/gtag/js?id=G-HMZJN1HYGP"></script>

          <script>

            { `window.dataLayer = window.dataLayer || [];

            function gtag(){dataLayer.push(arguments);}

            gtag('js', new Date());

          

            gtag('config', 'G-HMZJN1HYGP');`
            }
          </script>
          {/* Added Google Analytics  */}
      </Head>
       {session ? (
        <Modal
          message={"Session Expired"}
          title={"Login Session Status"}
          session={session}
          sessionTimeOutCheck={sessionTimeOutCheck}
          setSuccessModal={setSuccessModal}
          fail={true}
        />
      ) : null}
      <ToastContainer autoClose={1500} />
      <main style={{overflow:"hidden"}}>
       {/* {( getCurrentPath !== '/product' && !getCurrentPath.includes('/product_details/') && pageProps.path !== 'return-on-investment' && pageProps.path !== 'login' && pageProps.path !== 'logout') && <>*/}
        {(!isProductPage) && <>
          <div className="sideBtnWrapper !hidden">
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
              <button className={`rightFloatBtn rightBtn hideTooltipText ${textActive ? 'active' : ''}`}>
                ROI
              </button>
              {textActive && (
                <span className="Lst" onClick={() => goTo('/return-on-investment')}>
                 Click here to Check ROI of your Automation
                </span>
              )}
            </div>
          </div>
        </>}
        <Wrapper>
         <Component {...pageProps} routeChangeState={routeChangeState} />
        </Wrapper>
       </main>
    </Provider>
  );
}

const makestore = () => store;
const wrapper = createWrapper(makestore);

const mapStateToProps = (state) => {
  // console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}
export default wrapper.withRedux(
  connect(mapStateToProps, mapDispatchToProps)(MyApp),
);
